import FacialStore from "@/modules/device/store/facial/facial.store";
import BeaconStore from "@/modules/device/store/beacon/beacon.store";

export default {
  modules: {
    FacialStore,
    BeaconStore,
  },
};
